import React from 'react'
import PropTypes from 'prop-types'
import { isValid } from 'date-fns'
import { format } from 'utils/date'
import { Flex, Text } from '@jisr-hr/design-system'

import EmployeeProfile from '../EmployeeProfile'

const ProfileAndTime = ({ name, jobTitle, code, avatar, date, time, status, status_i18n }) => (
  <Flex
    justifyBetween
    itemsStart
  >
    <EmployeeProfile
      name={name}
      jobTitle={jobTitle}
      code={code}
      avatar={avatar}
      status={status}
      status_i18n={status_i18n}
    />
    <Text
      typography="paragraph14"
      color="rgba(6, 6, 43, 0.4)"
      as="div"
      align="end"
    >
      {isValid(new Date(date)) ? format(new Date(date), 'MMM dd, yyyy') : date} <br />
      {time}
    </Text>
  </Flex>
)

ProfileAndTime.propTypes = {
  code: PropTypes.number,
  name: PropTypes.string,
  jobTitle: PropTypes.string,
  avatar: PropTypes.string,
  time: PropTypes.string,
  status: PropTypes.string,
  status_i18n: PropTypes.string,
  date: PropTypes.instanceOf(Date),
}

export default ProfileAndTime
